<template>
  <PAlert
    v-for="(error, index) in nonFieldErrors"
    :key="index"
    class="mt-2"
    :type="AlertTypes.ERROR"
  >
    {{ error }}
  </PAlert>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { AlertTypes } from "@/interfaces/component/alert.interface.ts"
import PAlert from "@/components/elements/PAlert.vue"

const validation = defineModel<{ $errors: string[] | { $self?: string[] } }>({ required: true })
const nonFieldErrors = computed(() =>
  Array.isArray(validation.value.$errors)
    ? validation.value.$errors
    : (validation.value.$errors.$self ?? [])
)
</script>

<style scoped></style>
